import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

import { ToastNotificationsService } from '@shared/services/toast-notifications.service';

export const UNAUTHORIZED_INTERCEPTOR: HttpInterceptorFn = (request, next) => {
  const toastNotificationsService = inject(ToastNotificationsService);

  return next(request).pipe(
    tap({
      error: (error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case 403:
              toastNotificationsService.error(
                'You have no rights to perform this action'
              );
              break;

            case 401:
              toastNotificationsService.error(
                'You are unauthorized to perform this action'
              );
              break;
          }
        }
      }
    })
  );
};
